import React, { useEffect, useState } from 'react';
import Menu from '../../../components/sturtural/Menu';
import { BASE_API } from '../../../api/Globals';
import { Navigate } from 'react-router-dom';
import { helpHttp } from '../../../helpers/helpHttp';
import TableDataValidation from '../../../components/demand/TableDataValidation';
import Loader from '../../../components/sturtural/Loader';
import MessageDetail from '../../../components/sturtural/MessageDetail';
import { storage } from '../../../helpers/storage';

const DemandListRegistry = () => {
    const [db, setDb] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [solicitudid, setSolicitudId] = useState(null);
    const [statusid, setStatusId] = useState(null);
    
    let url = `${BASE_API}demand/registry`;

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then(res => {
            if(!res.err) {
                setDb(res.demand);
                setError(null);
            } else {
                setDb(null);
                setError(res);
            }
            setLoading(false);
        });
    },[url]);


    const handleValidation = (solicitudid, statusid) =>{
        window.localStorage.setItem('solicitudid', solicitudid);
        setSolicitudId(solicitudid);
        setStatusId(statusid)
    }

    const thead = [
        '#',
        'NOMBRE',
        'INSTITUCIÓN EDUCATIVA',
        'TÍTULO',
        'CORREO ELECTRÓNICO',
        'TELÉFONO',
        '...'
    ]

    return (
        <>
            
            {solicitudid && (statusid === 10 ? <Navigate to={'/cerrar-solicitud'} />:'')}

            <Menu link='solicitudes' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h5>Validación de solicitudes</h5>
                        <p>De la siguiente lista de solicitudes en espera, seleccione una para darle seguimiento.</p>
                        {loading && <Loader />}
                        {error && <MessageDetail color="error" mensaje={`Error ${error.status}: ${error.statusText}`} />}
                        {db && <TableDataValidation thead={thead} data={db} handleValidation={handleValidation} />}
                    </div>
                </div>
            </div>
        </>

    );
}

export default DemandListRegistry;